import React, { createContext, useState } from 'react';

export const GraphContext = createContext();

export const GraphProvider = ({ children }) => {
  // Cette fonctionnalité est maintenant publique par défaut
  // Les graphiques sont toujours activés pour tous les utilisateurs
  // Le state est conservé pour compatibilité avec le code existant
  const [graphEnabled, setGraphEnabled] = useState(true);

  return (
    <GraphContext.Provider value={{ graphEnabled, setGraphEnabled }}>
      {children}
    </GraphContext.Provider>
  );
}; 